export const parseZipCodes = (text, length, existing = []) => {
  const seen = new Set(existing)
  return String(text ?? '')
    .split(/[\s,]+/)
    .map(x => x.replace(/\D/g, ''))
    .filter(x => x.length === length && !seen.has(x) && seen.add(x))
}
